import { STATS_STATUS } from "@/constants";

export default {
  statsLoadInit(state, { query }) {
    state.query = query;
    state.logs = [];
    state.status = STATS_STATUS.LOADING;
    state.error = null;
  },
  statsLoadSuccess(state, { logs, done }) {
    state.logs = [...state.logs, ...logs];
    if (done) state.status = STATS_STATUS.LOAD_DONE;
  },
  statsLoadError(state, { error }) {
    state.error = error;
    state.status = STATS_STATUS.LOAD_ERROR;
  }
};
